module.exports = {
  ANOTHERVENUE: "anotherVenue",
  AVAILABILITY: "availability",
  NOREPLY: "noreply",
  EXPIRED: "expired",
  PRICE: "price",
  SUITABILITY: "suitablility",
  TERMS: "terms",
  OTHER: "other",
};
